const gtag = (...args) => {
    if (typeof window === 'undefined') {
        return;
    }
    if (typeof window.gtag === 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtagFunc() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
    }
    window.gtag(...args);
};
export { gtag };
//# sourceMappingURL=gtag.js.map